import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { COLORS } from '../../../consts/colors';

export const NewAddressLink = styled(Link)`
  color: ${COLORS.LIGHT_BLUE};
  margin-right: 5px;
`;
